<template>
  <div>
    <div class="header">
      <div class="header-info">
        <span v-if="true"> 设备信息  </span>
        <span v-if="true"> 物品数量: {{ submitTable.length }} 。 </span>
      </div>
      <div>
        <el-button v-if="operateStatus!=3" type="primary" plain round @click="delBatch">移除设备</el-button>
        <el-button v-if="operateStatus!=3" type="primary" plain round @click="addDevice">增加设备</el-button>
      </div>
    </div>
    <el-table
      :data="submitTable"
      :height="submitTable.length > 1 ? 140 : 120"
      border
      style="width: 100%"
      @selection-change="submitTabelSelect"
    >
       <el-table-column type="selection"></el-table-column>
       <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="name" label="设备名称" >
              <template slot-scope="scope" >
                   <span>{{scope.row.name}}</span><span v-if="scope.row.assetStatus==2" style="color:red"> (报废)</span>
              </template>
            </el-table-column>
            <el-table-column prop="code" label="设备编号" > </el-table-column>
            <el-table-column prop="typeName" label="设备类型">
                <!-- <template  slot-scope="scope">
                     <div>{{   getObjectTypeName(scope.row.objectType) }}</div>
                </template> -->
            </el-table-column>
            <el-table-column prop="model" label="设备型号" > </el-table-column>
            <el-table-column prop="startUseTime" label="启用时间" > </el-table-column>
            <el-table-column prop="purchasePrice" label="采购价格" align="right">
              <template slot-scope="scope" >
                  <div class="money" style="text-align:right"><span>{{tool.money_format_allowvoid(scope.row.purchasePrice)}}</span></div>
              </template>
            </el-table-column>
            <el-table-column prop="deptName" label="所属部门" > </el-table-column>
            
            <!-- <el-table-column prop="brand" label="设备品牌" width="160"> </el-table-column> -->
            
            <!-- <el-table-column prop="scrapTime" label="报废日期" width="120"> </el-table-column> -->
            <el-table-column prop="chargeManName" label="责任人" > </el-table-column>
            <el-table-column prop="areaName" label="存放位置" > </el-table-column>
            <el-table-column prop="" label="操作"  v-if="operateStatus!=3" align="center"> 
              <template slot-scope="scope" >
                <el-button
                  type="text"
                  size="small"
                  icon="el-icon-delete"
                  @click="remove(scope)"
                  >移除
                </el-button>
              </template>
            </el-table-column>
    </el-table>
   
    <hr-dialog title="增加设备" 
    v-if='choiceDeviceDialogFlag' 
    :visible="choiceDeviceDialogFlag" 
    width="90%" 
    append-to-body  
    :handleClose="choiceDeviceDialogClose" >
    <template v-slot:body>
      <el-form
      title="选择设备"
        :model="selectForm"
        ref="ruleForm"
        label-width="80px"
      >
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="设备类型" prop="objectType">
             <el-select
             ref='ruleSelect'
              :value="selectForm.typeName"
              placeholder="设备类型"
              style="width: 100%;"
            >
            <!-- :load="typeLazyLoadTree"
                  lazy -->
              <el-option :value="selectForm.typeId" show-all-levels :label="selectForm.typeName">
                <el-tree
                  node-key="id"
                  :data="treeFormData"
                  :props="treeProps"
                  
                  @node-click="typeNodeTreeClick"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属部门" prop="deptId">
           <el-select          
              :value="selectForm.deptName"
              placeholder="所属部门"
              style="width: 100%;"
              filterable 
              @focus="showDetpTree=true"
            >
              <el-option v-show="showDetpTree" :value="selectForm.deptName" show-all-levels :label="selectForm.deptName">
                <el-tree
                  node-key="id"
                  :data="treeFormDeptData"
                  :props="treeDeptProps"
                    @node-click="handleDeptNodeClick"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属区域" prop="areaId">
           
             <el-select
                :value="selectForm.areaName"
                placeholder="所属区域"
                style="width: 100%;"
              >
                <el-option :value="selectForm.areaName" show-all-levels :label="selectForm.areaName">
                  <el-tree
                    node-key="id"
                    :data="treeFormAreaData"
                    :props="areaTreeProps"
                    :load="areaLazyLoadTree"
                    lazy
                    @node-click="areaNodeTreeClick"
                  >
                  </el-tree>
                </el-option>
              </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="设备名称" prop="checkPass">
            <el-input v-model="selectForm.name" placeholder="设备名称"></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="24">
           <div style="display:flex;justify-content: end;margin-bottom:15px">
              <el-button type="primary" icon="el-icon-search"  size="small"   @click="search">搜索</el-button>
           <el-button icon="el-icon-delete" size="small" @click="searchReset">清空</el-button>
           </div>
          </el-col>
          <div style="padding:0 12git px;width=100%">
          <el-table :data="tableData"  :height="tableData.length > 1 ? 250 : 120" border style="width: 100%" @selection-change="choiceSelectionChange">
            <el-table-column type="selection" ></el-table-column>
            <el-table-column prop="name" label="设备名称" >
               <template slot-scope="scope" >
                   <span>{{scope.row.name}}</span><span v-if="scope.row.assetStatus==2" style="color:red"> (报废)</span>
              </template>
            </el-table-column>
            <el-table-column prop="code" label="设备编号" > </el-table-column>
            <el-table-column prop="typeName" label="设备类型">
                <!-- <template  slot-scope="scope">
                     <div>{{   getObjectTypeName(scope.row.objectType) }}</div>
                </template> -->
            </el-table-column>
            <el-table-column prop="model" label="设备型号" > </el-table-column>
            <el-table-column prop="startUseTime" label="启用时间" > </el-table-column>
            <el-table-column prop="purchasePrice" label="采购价格" align="right">
              <template slot-scope="scope" >
                  <div class="money" style="text-align:right"><span>{{tool.money_format_allowvoid(scope.row.purchasePrice)}}</span></div>
              </template>  
            </el-table-column>
            <el-table-column prop="deptName" label="所属部门" > </el-table-column>
            
            <!-- <el-table-column prop="brand" label="设备品牌" width="160"> </el-table-column> -->
            
            <!-- <el-table-column prop="scrapTime" label="报废日期" width="120"> </el-table-column> -->
            <el-table-column prop="chargeManName" label="责任人" > </el-table-column>
            <el-table-column prop="areaName" label="存放位置" > </el-table-column>
            
          </el-table>
          </div>
        </el-row>
      </el-form>
    </template>
    <template slot="footer">
      <div class="crud-submit">
      <el-button size="small" v-if="operateStatus!=3" type="primary"  icon="el-icon-circle-plus-outline"  @click="choiceSubmit">保存</el-button>
      <el-button size="small" @click="crudCancel" icon="el-icon-circle-close" style="margin-right:24px">取消</el-button>
    </div>
    </template>
    </hr-dialog>
  </div>
</template>

<script>
import { getChoiceDeviceList } from '@/api/crmedical/device/deviceInventory';
import { tree } from '@/api/crmedical/device/devicetype';
import { lazyAreaTree } from '@/api/crmedical/order/order-list/order-list';
import { getDictionary } from '@/api/common';
import { lazyTree } from '@/api/crmedical/project/area';
import { constants } from 'buffer';
import {
  getProjectDept,
  treeByProjectDeptId,
  childNode,
  userList,
} from '@/api/crmedical/device/device';
export default {
  props: {
    projectId: '',
    operateStatus: '', //操作类型
    submitTable: [], //提交的设备表
  },
  data() {
    return {
      userList: [],
      showDetpTree: false,
      colum: [],
      tableData: [],
      selectForm: {
        objectType: '',
        name: '',
        deptId: '',
        areaId: '',
        deptName: '',
        areaName: '',
        typeId: '',
        typeName: '',
      },
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'children',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'title',
      },
      treeDeptProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      areaTreeProps: {
        //标题
        label: 'name',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'name',
      },
      choiceDeviceDialogFlag: false,

      choiceSelectionList: [], //选中的设备
      submitTableChoice: [], //提交中的设备选中的,
      treeFormAreaData: [], //所属区域
      treeFormDeptData: [], //所属部门
      treeFormData: [], //设备类型
    };
  },
  created() {
    this.initData();
  },
  methods: {
    searchReset() {
      this.selectForm = {
        objectType: '',
        name: '',
        deptId: '',
        areaId: '',
        deptName: '',
        areaName: '',
        typeId: '',
        typeName: '',
      };
    },
    //单删
    remove(row){
      // let index = this.submitTable.findIndex(item=>{
      //   item.id == id
      // })
     
      // console.log('index',index)
      this.submitTable.splice(row.$index,1)
      // console.log(this.submitTable)
      this.$emit('returnChoiceDevice', this.submitTable);
    },
    //关闭批量增加对话框
    crudCancel() {
      this.choiceDeviceDialogFlag = false;
    },
    delBatch() {
      if(this.submitTableChoice.length<=0){
         this.$message({
          message: '请选择设备',
          type: 'warning'
        });
        return 
      }
      let arrId = [];  
      this.submitTableChoice.forEach((item) => {
        arrId.push(item.id);
      });
      let arr = [];
      this.submitTable.forEach((item) => {
        let flag;
        arrId.forEach((item1) => {
          if (item1 == item.id) {
            flag = true;
          }
        });
        if (!flag) {
          arr.push(item);
        }
      });
      this.submitTable = arr;
      this.$emit('returnChoiceDevice', this.submitTable);
    },
    addDevice() {
      this.choiceDeviceDialogFlag = true;
    },
    choiceDeviceDialogClose() {
      this.choiceDeviceDialogFlag = false;
    },
    search() {
      getChoiceDeviceList(Object.assign({ projectId: this.projectId }, this.selectForm)).then(
        ({ data }) => {
          this.tableData = data;
        }
      );
    },
    initData() {
      getDictionary('device_object_type').then(({ data }) => {
        this.objectType = data;
      });
      this.queryAreaSelect(this.projectId);
      this.treeByProjectDeptId(this.projectId);
      this.queryDeviceSelect(this.projectId);
    },
    getObjectTypeName(dictKey) {
      let ObjectTypeName;
      this.objectType.forEach((element) => {
        if (element.dictKey == dictKey) {
          ObjectTypeName = element.dictValue;
        }
      });
      return ObjectTypeName;
    },
    //选中的设备提交
    choiceSubmit() {
      this.submitTable = [...this.choiceSelectionList, ...this.submitTable];
      let obj = {};
      //去重
      this.submitTable = this.submitTable.reduce((item, next) => {
        obj[next.id] ? '' : (obj[next.id] = true && item.push(next));
        return item;
      }, []);
      console.log('this.submitTable', this.submitTable);
      this.$emit('returnChoiceDevice', this.submitTable);

      this.choiceDeviceDialogFlag = false;
    },
    //选中的设备
    choiceSelectionChange(val) {
      this.choiceSelectionList = val;
    },
    submitTabelSelect(val) {
      this.submitTableChoice = val;
    },
    queryAreaSelect(value) {
      lazyTree({ parentId: 0, projectId: value }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
            if (item.nodeType === 1) {
              item.disabled = true;
            }
          });
        }
        this.treeFormAreaData = data;
      });
    },
    queryDeviceSelect(value) {
      tree({ id: 0, projectId: value, objectType: 1 }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.treeFormData = data;
      });
    },
    typeNodeTreeClick(node) {
      console.log(node);
      let nodeId = node.id;
      let nodeTitle = node.title;
      this.selectForm.typeName = nodeTitle;
      this.selectForm.typeId = nodeId;
      console.log(
      this.$refs.ruleSelect
      );
      this.$refs.ruleSelect.blur()
    },
    areaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      lazyAreaTree({ parentId: id, projectId: this.projectId }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        resolve(data);
      });
    },
    areaNodeTreeClick(node) {
      // if (parseInt(node.nodeType) == 1) {
      //   // this.$message.error();
      //   return;
      // }
      let nodeId = node.id;
      let nodeTitle = node.name;
      this.selectForm.areaName = nodeTitle;
      this.selectForm.areaId = nodeId;
    },
    treeByProjectDeptId(value) {
      treeByProjectDeptId({ projectId: value }).then((res) => {
        this.treeFormDeptData = res.data;
      });
    },
    handleDeptNodeClick(node) {
      //  if (parseInt(node.nodeType) == 1) {
      //     // this.$message.error();
      //     return;
      //   }
      let nodeId = node.id;
      let nodeTitle = node.title;
      this.selectForm.deptName = nodeTitle;
      this.selectForm.deptId = nodeId;
      console.log(node);
    },
    typeLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      tree({ id: id, projectId: this.projectId, objectType: 1 }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        } else {
          data = [];
        }
        resolve(data);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  padding: 0 10px;
  background-color: #fff;
  border-left: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}
::v-deep .avue-crud__tip {
  display: none;
}
::v-deep .avue-crud__pagination {
  margin-bottom: 10px !important;
}
::v-deep .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 10px;
}
.add {
  height: 44px;
  line-height: 44px;
  text-align: center;
  border: 1px dashed #333;
  background-color: #fff;
}
//
.crud-submit {
  display: flex;
  justify-content: end;
  align-items: center;
  height: 50px;
}
::v-deep .errorBorder .el-input__inner {
  border: 1px solid #f00;
}
.errorText {
  color: #f00;
  font-size: 12px;
  text-align: left;
}
::v-deep .avue-crud {
  min-height: 420px;
}

</style>
